module.exports = __webpack_public_path__ + "static/media/messages.60e6b5f1.svg";